// extracted by mini-css-extract-plugin
export default {"service_cont":"Services_service_cont__jrtLb","stands_grid":"Services_stands_grid__GlRAq","stand_grid1":"Services_stand_grid1__+RatL"};